module.exports = __webpack_public_path__ + "static/img/brees500-intro-img.131f9cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees500-intro-img.jpg
// module id = v99L
// module chunks = 1